import { useOverlayTriggerState } from '@react-stately/overlays';
import { createContext, useContext } from 'react';

type TMegaMenuContext = {
  megaMenuState: ReturnType<typeof useOverlayTriggerState>,
  settingsMenuState: ReturnType<typeof useOverlayTriggerState>,
};

export const MegaMenuContext = createContext<TMegaMenuContext>({
  megaMenuState: null,
  settingsMenuState: null,
});

export const useMegaMenu = (): ReturnType<typeof useContext<TMegaMenuContext>> => {
  return useContext(MegaMenuContext);
};
